import React from "react";
import ShonenContent from "../DimensionContent/ShonenDimension"
import Music from "./shonenmusic"
import Data from "../SliceOfLifeDimension/data"

const Shonen=()=>{

    return(
       <div>       
       <ShonenContent/>
       <Music/>
<Data/>
       </div>
    )
}
export default Shonen


// WEBPACK FOOTER //
// ./src/Dimension/ShonenDimension/Shonen.jsx